































































































































































































































































import Vue, { PropType } from "vue";

import axios from "axios";
import moment from "moment";
import type { EditorConfiguration } from "codemirror";

import store, { emptyCorporateReviewForm } from "@/store";
import { genericExtension } from "@/properties";
import ReviewHeader from "@/parts/review/ReviewHeader.vue";
import VariableInput from "@/components/util/VariableInput.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import { codemirror } from "vue-codemirror";
import AddSkillModal from "@/parts/util/AddSkillModal.vue";
import { getDaysCountToEndDate } from "@/utils/momentUtils";
import HelperTooltip from "@/parts/common/HelperTooltip.vue";
import { getColorClass } from "@/utils/styleUtils";

import { getProjects } from "@/api/Corporation";
import {
  createReview,
  updateReview,
  updateReviewStatus,
  getReview,
  deleteReview,
  registerZipFile,
} from "@/api/ReviewCorporate";
import { Project } from "@/api/dto/Corporation";
import { ErrorResponse } from "@/api/dto/Error";
import { Code, ZipFile, GithubUrl } from "@/api/dto/CorporateDealType";
import { CodeEditorSegmegment } from "@/api/dto/CodeEditor";
import { Language, SkillMastar } from "@/api/dto/Skill";
import { UserProfile } from "@/api/dto/UserProfile";
import { ReviewResponse, RegisterCorporateReviewCommentZipFile } from "@/api/dto/ReviewCorporate";
import { Draft, UnderReview, AgreementPending, InReview, Completed } from "@/views/corporate/forms/DealStatus";
import {
  CorporateReviewForm,
  toCreateReviewRequestFromReviewForm,
  toUpdateReviewRequestFromReviewForm,
  toReviewFormFromReviewResponse,
} from "@/views/corporate/review/ReviewForm";

export interface SelectProject {
  value: number;
  text: string;
  projectIconUrl: string;
  id: string;
}

export default Vue.extend({
  name: "CorpReviewEdit",
  components: {
    ReviewHeader,
    VariableInput,
    SelectBox,
    codemirror,
    AddSkillModal,
    HelperTooltip,
  },
  props: {
    mq: String,
  },
  data() {
    return {
      reviewData: {} as CorporateReviewForm,
      // メイン言語 関連
      mainLangModal: false,
      // コードエディター 関連
      countCodeBlock: 0,
      optionExtension: [] as { value: number; text: string }[],
      code: [] as Array<string>,
      cmOptions: [] as Array<EditorConfiguration>,
      selectedCodeEditor: 0,
      // タグ 関連
      tagLangModal: false,
      // モーダル 関連
      modalOpen: false,
      leaveModal: false,
      deleteEditorModal: false,
      deleteModal: false,
      draftModal: false,
      // 汎用
      allowLeave: false,
      goBack: false,
      nextPath: "",
      // 変更前の言語
      beforeLanguage: "",
      showReceptionFin: false,
      disabledUseCoupon: false,
      disabledPurchaseType: false,
      disabledAmount: false,
      project: 0,
      themes: [
        { name: "dark", value: "DarkMode", text: "ダークモード", url: "/images/mypage/setting_dark.svg" },
        { name: "light", value: "LightMode", text: "ライトモード", url: "/images/mypage/setting_light.svg" },
      ],
      file: null as File | null,
      fileUrl: null as string | null,
      githubUrlPrefix: "https://github.com/",
      projects: [] as Project[],
      selectProject: [] as SelectProject[],
    };
  },
  async beforeRouteEnter(to, route, next) {
    let reviewForm = {};
    if (!(to.path == "/corporate/draft")) {
      reviewForm = toReviewFormFromReviewResponse(await getReview(to.params.dealId));
    }

    next((vm) => {
      if (vm.$route.params.from != "Confirm") {
        vm.$store.dispatch("initCorporateReviewForm");
        vm.$store.dispatch("initCorporateReviewFile");
      }
      if (!(to.path == "/corporate/draft")) {
        vm.$data.reviewData = reviewForm;
        if (vm.$data.reviewData.codeEditor == null) {
          vm.$data.reviewData.codeEditor = [] as CodeEditorSegmegment[];
        }
        vm.$data.fileUrl = vm.$data.reviewData.fileUrl;
        if (vm.$data.reviewData.dealType != Code) {
          return;
        }
        let setCodemirror = (codeEditor: CodeEditorSegmegment[]) => {
          var code = [] as Array<string>;
          var cmOptions = [] as Array<EditorConfiguration>;
          let theme = vm.$store.getters.userProfile.codeTheme == "2" ? "base16-light" : "base16-dark";
          for (var i = 0; i < codeEditor.length; i++) {
            let text = codeEditor[i].text;
            let string = "";
            for (var j = 0; j < text.length; j++) {
              if (j === text.length - 1) {
                string += text[j].code;
              } else {
                string += text[j].code + "\n";
              }
            }
            code.push(string);
            cmOptions.push({
              theme: theme,
              tabSize: 4,
              lineNumbers: true,
              lineWrapping: true,
              mode: codeEditor[i].extension,
              readOnly: false,
            });
          }
          vm.$data.code = code;
          vm.$data.cmOptions = cmOptions;
        };

        let addCodeEditor = () => {
          vm.$data.countCodeBlock += 1;
          var ret = ("00" + vm.$data.countCodeBlock).slice(-2);
          var defaultName = "code-" + ret;
          vm.$data.reviewData.codeEditor.push({
            fileName: defaultName,
            extension: "",
            text: [
              {
                line: 1,
                code: "",
              },
            ],
            remarks: "",
          });
          let theme = vm.$store.getters.userProfile.codeTheme == "2" ? "base16-light" : "base16-dark";
          vm.$data.code.push("");
          vm.$data.cmOptions.push({
            theme: theme,
            tabSize: 4,
            lineNumbers: true,
            lineWrapping: true,
            mode: "",
            readOnly: false,
          });
        };

        if (vm.$data.reviewData.codeEditor.length) {
          setCodemirror(vm.$data.reviewData.codeEditor);
        } else {
          addCodeEditor();
        }
      }
    });
  },
  mounted() {
    if (this.mq == "sp") {
      this.$emit("errorToast", "スマートフォンからは依頼作成・編集ができません。");
      this.$router.push({ name: "Top" });
    }
    // アカウントステータスの確認
    if (this.loginData.accountStatus == "3") {
      this.allowLeave = true;
      this.$emit("errorToast", "アカウント制限中のため、依頼作成ができません。");
      this.$router.push({ name: "Top" });
    }

    this.initData();
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.$browserBackFlg) {
      // ブラウザバック以外の場合
      // ガイド.よくある質問は別タブ
      if (to.path == "/guide" || to.path == "/faq") {
        window.open(to.path, "_blank");
        return;
      }
    }
    if (!this.allowLeave && (await this.editDone())) {
      this.goBack = this.$browserBackFlg;
      this.leaveModalOpen(to.path);
      this.allowLeave = false;
      next(false);
      return;
    }
    this.allowLeave = false;
    next();
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    dealId(): string {
      return this.$route.params.dealId;
    },
    isNewReview(): boolean {
      return this.$route.path == "/corporate/draft";
    },
    // タグ 関連
    splitTags(): string[] {
      var tags = this.reviewData.tags;
      if (tags) {
        return this.reviewData.tags.split(",");
      } else {
        return [];
      }
    },
  },
  methods: {
    // レビュー取得
    async getReview(dealId: string) {
      try {
        const res = await getReview(dealId);
        if (res.purchaseUserId == this.loginData.userId && (res.dealStatus == Draft || res.dealStatus == UnderReview)) {
          return toReviewFormFromReviewResponse(res);
        }
      } catch (e) {
        console.log(e);
      }
    },
    /** 編集したかどうか */
    async editDone(): Promise<boolean> {
      this.allowLeave = true;
      if (this.reviewData.dealType == Code && this.reviewData.codeEditor.length != 0) {
        this.setFormCode();
      }
      if (this.isNewReview) {
        // 編集有無を判定する
        const initialReviewData: CorporateReviewForm = emptyCorporateReviewForm();
        const currentReviewData = this.reviewData;
        let isEdited = Object.entries(currentReviewData).some(([key, value]) => {
          switch (key) {
            case "codeEditor":
              const codeEditor = value as CodeEditorSegmegment[];
              // エディタ行が追加されている場合、編集有りと判定
              if (codeEditor.length > 1) {
                return true;
              }
              const [firstCodeEditor] = codeEditor;
              // 何かしらコードエディタの入力内容が変わっていれば、編集有りと判定
              return (
                firstCodeEditor.fileName !== "code-01" ||
                firstCodeEditor.extension !== "" ||
                firstCodeEditor.remarks !== "" ||
                firstCodeEditor.text.some(({ code }) => !!code)
              );
            case "githubUrl":
              return currentReviewData.githubUrl && this.sliceGithubUrl(currentReviewData.githubUrl) != "";
            case "projectName":
              return this.project != 0;
            case "projectId":
            case "projectIconUrl":
              return false;
            default:
              return value !== initialReviewData[key as keyof CorporateReviewForm];
          }
        });
        if (this.file != null) {
          isEdited = true;
        }
        return isEdited;
      } else {
        // DB保存の依頼内容と比較し、編集有無を判定する
        const currentReviewData = this.reviewData;
        const dbReviewData = toReviewFormFromReviewResponse(await getReview(this.reviewData.dealId as string));

        if (this.file) {
          return true;
        }

        if (dbReviewData.codeEditor == null && currentReviewData.codeEditor != null) {
          // コードタイプでなくても拡張子が選択言語によって変動するため、比較対象から除外（拡張子；Json化後に比較）
          if (
            currentReviewData.codeEditor[0].fileName !== "code-01" ||
            currentReviewData.codeEditor[0].remarks !== ""
          ) {
            return true;
          }
        }

        const convertedDbData = { ...dbReviewData } as CorporateReviewForm;
        const convertedNewData = { ...this.reviewData } as CorporateReviewForm;

        convertedDbData.codeEditor ??= [] as CodeEditorSegmegment[];
        if (convertedNewData.dealType != Code) {
          convertedNewData.codeEditor = [] as CodeEditorSegmegment[];
        }
        // URL系は変更に関与しない（比較対象から除外）＋　URLのSignatureに相違が出るため初期化
        [convertedDbData, convertedNewData].forEach((data, i) => {
          data.projectIconUrl = "";
          if (data.fileUrl) {
            data.fileUrl = null;
          }
        });

        const dbJSON = JSON.stringify(convertedDbData);
        const newJSON = JSON.stringify(convertedNewData);

        if (newJSON != dbJSON) {
          return true;
        } else {
          return false;
        }
      }
    },
    async initData() {
      this.projects = await getProjects();
      const storeReviewForm = this.$store.getters.corporateReviewForm as CorporateReviewForm;
      this.file = this.$store.getters.corporateReviewFile as File | null;
      if (storeReviewForm.dealId == this.dealId && storeReviewForm.title) {
        this.reviewData = JSON.parse(JSON.stringify(storeReviewForm));
      } else {
        this.$store.dispatch("initCorporateReviewForm");
        this.$store.dispatch("initCorporateReviewFile");
        if (this.isNewReview) {
          this.reviewData = JSON.parse(JSON.stringify(this.$store.getters.corporateReviewForm as CorporateReviewForm));
        }
      }
      if (!this.reviewData.projectId) {
        this.reviewData.projectId = this.projects[0].id;
        this.reviewData.projectName = this.projects[0].projectName;
        this.reviewData.projectIconUrl = this.projects[0].iconUrl;
      }
      this.projects.forEach((project, i) => {
        this.selectProject.push({
          value: i,
          text: project.projectName,
          projectIconUrl: project.iconUrl,
          id: project.id,
        });
        if (this.reviewData.projectId == project.id) {
          this.project = i;
        }
      });
      this.setOptionExtension();
      if (this.reviewData.codeEditor.length) {
        this.setCodemirror(this.reviewData.codeEditor);
      } else {
        this.addCodeEditor();
      }
    },
    // メイン言語 関連
    setFormLanguage(value: string) {
      this.beforeLanguage = this.reviewData.language;
      this.reviewData.language = value;
      this.changeExtToChoseLanguage(value);
    },
    // コードエディター 関連
    setOptionExtension() {
      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var abstractExtension = localSkill.filter((v) => v.type == Language).map((v) => v.extension);
      var extensionList = abstractExtension.concat(genericExtension).sort();
      this.optionExtension.push({ value: 0, text: "入力してください" });
      for (var i = 0; i < extensionList.length; i++) {
        this.optionExtension.push({ value: i + 1, text: "." + extensionList[i] });
      }
      this.optionExtension.push({ value: extensionList.length + 1, text: "その他" });
    },
    setInitialExt(ext: string) {
      if (ext !== "") {
        var extObject = this.optionExtension.filter((v) => v.text === ext);
        if (extObject.length) {
          return extObject[0].value;
        } else {
          return this.optionExtension.length - 1;
        }
      } else {
        return 0;
      }
    },
    changeExt(newExt: number, key: number) {
      var match = this.optionExtension.filter((v) => v.value === newExt)[0];
      if (match.text === "入力してください") {
        this.reviewData.codeEditor[key].extension = "";
        if (this.cmOptions[key]) {
          // コードミラーオプションを生成する前に走る予防
          this.cmOptions[key].mode = "";
        }
      } else {
        this.reviewData.codeEditor[key].extension = match.text;
        if (this.cmOptions[key]) {
          // コードミラーオプションを生成する前に走る予防
          this.cmOptions[key].mode = match.text;
        }
      }
    },
    changeExtToChoseLanguage(lang: string) {
      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var extensions = localSkill.filter((v) => v.skillName == lang).map((v) => v.extension);
      var beforeExtensions = localSkill.filter((v) => v.skillName == this.beforeLanguage).map((v) => v.extension);
      if (!extensions.length) {
        return;
      }
      var extensionOfSelectedLanguage = this.optionExtension.filter((c) => c.text == "." + extensions[0])[0];
      this.reviewData.codeEditor.forEach((c) => {
        if ((beforeExtensions.length != 0 && c.extension == "." + beforeExtensions[0]) || c.extension == "") {
          // 選択言語変更時、変更前の言語とマッチする拡張子または拡張子が選択されていない場合に拡張子の変更を行う
          c.extension = lang == "その他" ? "" : extensionOfSelectedLanguage.text;
        }
      });
    },
    // タグ 関連
    setFormTags(value: string[]) {
      this.reviewData.tags = value.join(",");
    },
    deleteTags(index: number) {
      this.splitTags.splice(index, 1);
      this.setFormTags(this.splitTags);
    },
    setCodemirror(codeEditor: CodeEditorSegmegment[]) {
      var code = [] as Array<string>;
      var cmOptions = [] as Array<EditorConfiguration>;
      let theme = this.loginData.codeTheme == "2" ? "base16-light" : "base16-dark";
      for (var i = 0; i < codeEditor.length; i++) {
        let text = codeEditor[i].text;
        let string = "";
        for (var j = 0; j < text.length; j++) {
          if (j === text.length - 1) {
            string += text[j].code;
          } else {
            string += text[j].code + "\n";
          }
        }
        code.push(string);
        cmOptions.push({
          theme: theme,
          tabSize: 4,
          lineNumbers: true,
          lineWrapping: true,
          mode: codeEditor[i].extension,
          readOnly: false,
        });
      }
      this.code = code;
      this.cmOptions = cmOptions;
    },
    addCodeEditor() {
      if (this.reviewData.codeEditor) {
        this.countCodeBlock = this.reviewData.codeEditor.length + 1;
      } else {
        this.countCodeBlock += 1;
      }
      var ret = ("00" + this.countCodeBlock).slice(-2);
      var defaultName = "code-" + ret;

      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var extensions = localSkill.filter((v) => v.skillName == this.reviewData.language).map((v) => v.extension);
      var extensionOfSelectedLanguage = "";
      if (extensions.length != 0) {
        extensionOfSelectedLanguage =
          this.reviewData.language == "その他"
            ? ""
            : this.optionExtension.filter((c) => c.text == "." + extensions[0])[0].text;
      }

      this.reviewData.codeEditor.push({
        fileName: defaultName,
        extension: extensionOfSelectedLanguage,
        text: [
          {
            line: 1,
            code: "",
          },
        ],
        remarks: "",
      });
      let theme = this.loginData.codeTheme == "2" ? "base16-light" : "base16-dark";
      this.code.push("");
      this.cmOptions.push({
        theme: theme,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
        mode: "",
        readOnly: false,
      });
    },
    changeProject(event: Event) {
      const target = event.target as HTMLInputElement;
      const project = parseInt(target.value);
      this.project = project;
      this.reviewData.projectName = this.selectProject[project].text;
      this.reviewData.projectIconUrl = this.selectProject[project].projectIconUrl;
      this.reviewData.projectId = this.selectProject[project].id;
    },
    deleteCodeEditor() {
      this.reviewData.codeEditor.splice(this.selectedCodeEditor, 1);
      this.code.splice(this.selectedCodeEditor, 1);
      this.cmOptions.splice(this.selectedCodeEditor, 1);
      this.modalClose();
    },
    setFormCode() {
      for (var i = 0; i < this.code.length; i++) {
        this.reviewData.codeEditor[i].text = [];
        if (!this.code[i]) {
          continue;
        }
        var code = this.code[i].split(/\n/);
        for (var j = 0; j < code.length; j++) {
          this.reviewData.codeEditor[i].text.push({ line: j + 1, code: code[j] });
        }
      }
    },
    /** DL URLからファイル名を抽出 */
    extractionFileName(url: string): string | null {
      const regex = /\/([^/]+\.zip)_/;
      const match = url.match(regex);
      if (match) {
        return match[1];
      } else {
        return null;
      }
    },
    // GithubUrl関連
    updateInputGithubUrlValue(e: Event) {
      e.preventDefault();
      if (!(e?.target instanceof HTMLInputElement)) {
        return;
      }
      if (e.target.value.trim() == "") {
        this.reviewData.githubUrl = null;
        return;
      }
      this.reviewData.githubUrl = this.githubUrlPrefix + e.target.value;
    },
    sliceGithubUrl(url: string): string {
      if (!url || url == "") {
        return "";
      }
      return url.slice(this.githubUrlPrefix.length);
    },
    // モーダル 関連
    leaveModalOpen(path: string) {
      this.modalOpen = true;
      this.leaveModal = true;
      this.nextPath = path;
    },
    deleteEditorModalOpen(index: number) {
      this.modalOpen = true;
      this.deleteEditorModal = true;
      this.selectedCodeEditor = index;
    },
    deleteModalOpen() {
      this.modalOpen = true;
      this.deleteModal = true;
    },
    draftModalOpen() {
      this.modalOpen = true;
      this.draftModal = true;
    },
    modalClose() {
      this.modalOpen = false;
      this.leaveModal = false;
      this.deleteEditorModal = false;
      this.deleteModal = false;
      this.draftModal = false;
    },
    /** 確認画面へ遷移 */
    toConfirm() {
      this.reviewSubmit("confirm");
    },
    /** 詳細か依頼一覧（新規の場合）へ遷移 */
    goBackDetailOrRequestList() {
      this.allowLeave = true;
      if (this.reviewData.dealId) {
        this.$router.push({ name: "CorpReview", params: { dealId: this.reviewData.dealId } });
      } else {
        this.$router.push({ name: "CorpRequest" });
      }
    },
    /** レビュー削除 */
    async deleteReview() {
      try {
        await deleteReview(this.reviewData.dealId as string);
        this.$store.dispatch("initCorporateReviewForm");
        this.$store.dispatch("initCorporateReviewFile");
        this.allowLeave = true;
        this.$router.push({ name: "CorpRequest" });
      } catch (e) {
        console.log(e);
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "レビューの削除に失敗しました。しばらく経ってからやり直してください。");
          } else {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
    /** 下書き保存 */
    saveDraft() {
      this.reviewSubmit("draft");
    },
    /** 下書きに戻す */
    backDraft() {
      this.reviewSubmit("draftBack");
    },
    /** 破棄 */
    destroy() {
      this.modalClose();
      this.$store.dispatch("initCorporateReviewForm");
      this.$store.dispatch("initCorporateReviewFile");
      this.allowLeave = true;
      this.$router.push({ name: "CorpRequest" });
    },
    /** ページ離脱による下書き保存 or 編集内容を保存 */
    saveLeave() {
      this.reviewSubmit("save");
    },
    /** ドラッグ＆ドロップによるファイル検知 */
    handleDrop(event: DragEvent) {
      event.preventDefault();
      const files = event.dataTransfer?.files;
      if (files && files.length > 0) {
        this.uploadFile(files[0]);
      }
    },
    /** クリックによるファイル検知 */
    handleFileChange(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        this.uploadFile(files[0]);
      }
      target.value = "";
    },
    /** 添付ファイル登録 */
    uploadFile(file: File | undefined) {
      if (!file) return;
      if (this.hasErrFile(file)) {
        return;
      }
      this.file = file;
    },
    /** 添付ファイル削除 */
    deleteFile() {
      this.file = null;
      this.fileUrl = null;
    },
    /** Zipファイルバリデーション */
    hasErrFile(file: File): boolean {
      // 拡張子のチェック
      const validExtensions = /^(\.zip|\.rar|\.7z)$/i;
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      if (!validExtensions.test("." + fileExtension)) {
        this.$emit("errorToast", "無効なファイル形式です。許可されている形式は .zip / .7z / .rar です。");
        return true;
      }

      // ファイルサイズのチェック（10MBまで許容）
      const maxFileSizeInBytes = 10 * 1024 * 1024; // 10MB
      if (file.size > maxFileSizeInBytes) {
        this.$emit("errorToast", "ファイルサイズが大きすぎます。10MB以下のZIPファイルを選択してください。");
        return true;
      }
      return false;
    },
    /** 入力フォームチェック */
    validation(action: string) {
      var form = this.reviewData;
      var maxTitleLength = 100;
      var maxPurchaseOverviewLength = 500;
      var maxFileNameLength = 50;

      // 下書き保存"以外の場合"にチェックする項目
      if (
        !["draft"].includes(action) &&
        !(["save"].includes(action) && (this.isNewReview || form.dealStatus == Draft))
      ) {
        // 言語
        if (!form.language.trim()) {
          return { result: false, message: "言語を選択してください" };
        }
        // タイトル
        if (!form.title.trim()) {
          return { result: false, message: "タイトルを入力してください" };
        }
        // 依頼概要
        if (!form.purchaseOverview.trim()) {
          return { result: false, message: "依頼概要を入力してください" };
        }
        switch (this.reviewData.dealType) {
          case Code:
            const codeValidation = this.validateCode(form, maxFileNameLength);
            if (codeValidation.result) {
              break;
            } else {
              return codeValidation;
            }
          case ZipFile:
            if (!this.file && !this.fileUrl) {
              return { result: false, message: "Zipファイルを登録してください。" };
            }
            break;
          case GithubUrl:
            if (!form.githubUrl || form.githubUrl.trim() == "") {
              return { result: false, message: "GithubのURLを入力してください。" };
            }
            break;
        }
      }
      // 状態関係なく共通でチェックする項目
      // タイトル（文字数）
      if (form.title.trim() && form.title.length > maxTitleLength) {
        return {
          result: false,
          message: "タイトルを" + maxTitleLength + "文字以内で入力してください。文字数：" + form.title.length,
        };
      }
      // プロジェクト
      if (!form.projectId.trim()) {
        return { result: false, message: "プロジェクトを選択してください" };
      }
      // 依頼概要（文字数）
      if (form.purchaseOverview.trim() && form.purchaseOverview.length > maxPurchaseOverviewLength) {
        return {
          result: false,
          message:
            "依頼概要を" +
            maxPurchaseOverviewLength +
            "文字以内で入力してください。文字数：" +
            form.purchaseOverview.length,
        };
      }
      // Zipファイル名
      if (this.file != null && this.file.name.length > maxFileNameLength) {
        return { result: false, message: "ZIPファイル名は、拡張子を含め'50文字以内'にしてください。" };
      }

      return { result: true, message: "" };
    },
    validateCode(form: CorporateReviewForm, fileNameLength: number): { result: boolean; message: string } {
      // コードエディタ
      for (let i = 0; i < form.codeEditor.length; i++) {
        const codeEditor = form.codeEditor[i];

        // NOTE: 以下に該当する場合は、ファイル名・拡張子のチェックを行う
        //       ・1つ目のコードエディタの場合
        //       ・2つ目以降のコードエディタ 且つ コード本文の入力がある場合
        if (i === 0 || (i > 0 && !!codeEditor.text.length)) {
          // ファイル名
          if (!codeEditor.fileName.trim()) {
            return { result: false, message: "ファイル名を入力してください" };
          }
          if (codeEditor.fileName.length > fileNameLength) {
            return {
              result: false,
              message:
                "ファイル名を" +
                fileNameLength +
                "文字以内で入力してください。対象ファイル名：" +
                codeEditor.fileName +
                codeEditor.extension +
                "、文字数：" +
                codeEditor.fileName.length,
            };
          }
          // 拡張子
          if (!codeEditor.extension) {
            return { result: false, message: "すべてのエディタで拡張子を選択してください" };
          }
          // ファイル名+拡張子の重複
          const duplicate = form.codeEditor.filter(
            (v) => v.fileName == codeEditor.fileName && v.extension == codeEditor.extension
          );
          if (duplicate.length > 1) {
            return {
              result: false,
              message: "ファイル名が重複しています。対象ファイル名：" + codeEditor.fileName + codeEditor.extension,
            };
          }
        }
        // 1つ目のコードエディタのみ、コード本文の入力は必須とする
        if (i === 0) {
          // コード本文
          if (!codeEditor.text.length) {
            return {
              result: false,
              message: "コード本文を入力してください。対象ファイル名：" + codeEditor.fileName + codeEditor.extension,
            };
          }
        }
      }
      return { result: true, message: "" };
    },
    /** 不要な空白除去 */
    format() {
      var form = this.reviewData;
      form.title = form.title.trim();
      form.purchaseOverview = form.purchaseOverview.trim();
    },
    /** レビュー送信（汎用） */
    async reviewSubmit(action: string) {
      if (this.reviewData.dealType == Code && this.reviewData.codeEditor.length != 0) {
        this.setFormCode();
      }
      // 「保存・下書き保存」以外はバリデーションチェック
      var validation = this.validation(action);
      if (!validation.result) {
        this.$emit("errorToast", validation.message);
        return;
      }

      this.format();
      // 登録・更新時に不要な依頼コンテンツを削除
      this.deleteDealContentsNotNeed();

      if (action == "confirm") {
        var codeEditor: CodeEditorSegmegment[] = [];
        if (this.reviewData.dealType == Code && this.reviewData.codeEditor.length != 0) {
          codeEditor = this.reviewData.codeEditor.filter(({ text }) => !!text.length);
        }
        this.$store.dispatch("updateCorporateReviewForm", {
          form: {
            ...this.reviewData,
            codeEditor,
          },
        });
        if (this.reviewData.dealType == ZipFile && this.file) {
          this.$store.dispatch("uploadCorporateReviewFile", this.file);
        }
        this.allowLeave = true;
        if (this.isNewReview) {
          this.$router.push({ name: "CorpDraftConfirm" });
        } else {
          this.$router.push({ name: "CorpConfirm", params: { dealId: this.reviewData.dealId as string } });
        }
      } else if (action == "draft") {
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData, Draft));
            this.reviewData.dealId = res.dealId;
            if (this.file != null) {
              const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
                dealId: this.reviewData.dealId!,
                isComment: false,
                zipFile: this.file,
              };
              res = await registerZipFile(registerZipFileReq);
            }
            this.reviewData.createDate = res.createDate;
            this.reviewData.dealStatus = "1";
            this.$emit("toast", "下書き保存しました");
            this.$store.dispatch("updateCorporateReviewForm", { form: this.reviewData });
            this.allowLeave = true;
            this.$router.replace({ name: "CorpReviewEdit", params: { dealId: this.reviewData.dealId } });
          } else {
            // レビュー更新API 取引ステータス:変更なし
            var updatedRes = await updateReview(
              this.reviewData.dealId as string,
              toUpdateReviewRequestFromReviewForm(this.reviewData, this.reviewData.dealStatus)
            );
            if (this.file != null) {
              const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
                dealId: this.reviewData.dealId!,
                isComment: false,
                zipFile: this.file,
              };
              updatedRes = await registerZipFile(registerZipFileReq);
            }
            this.reviewData = toReviewFormFromReviewResponse(updatedRes);
            this.$emit("toast", "下書き保存しました");
          }
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "下書き保存に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      } else if (action == "draftBack") {
        try {
          // レビュー更新API 取引情報更新 & ステータス更新:（査定中 or 承諾待ち⇒下書き）
          await updateReview(
            this.reviewData.dealId as string,
            toUpdateReviewRequestFromReviewForm(this.reviewData, this.reviewData.dealStatus)
          );
          if (this.file != null) {
            const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
              dealId: this.reviewData.dealId!,
              isComment: false,
              zipFile: this.file,
            };
            await registerZipFile(registerZipFileReq);
          }
          var updatedRes = await updateReviewStatus(this.reviewData.dealId as string, { dealStatus: Draft });
          this.reviewData = updatedRes;
          this.modalClose();
          this.$emit("toast", "下書きに戻しました");
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "下書きへの更新に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      } else if (action == "save") {
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            const res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData, Draft));
            this.reviewData.dealId = res.dealId;
            if (this.file != null) {
              const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
                dealId: this.reviewData.dealId!,
                isComment: false,
                zipFile: this.file,
              };
              await registerZipFile(registerZipFileReq);
            }
            this.$emit("toast", "下書き保存しました");
          } else {
            // レビュー更新API 取引ステータス:変更なし
            await updateReview(
              this.reviewData.dealId as string,
              toUpdateReviewRequestFromReviewForm(this.reviewData, this.reviewData.dealStatus)
            );
            if (this.file != null) {
              const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
                dealId: this.reviewData.dealId!,
                isComment: false,
                zipFile: this.file,
              };
              await registerZipFile(registerZipFileReq);
            }
            this.$emit("toast", "編集内容を保存しました");
          }
          this.destroy();
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              if (this.isNewReview) {
                this.$emit("errorToast", "下書き保存に失敗しました。しばらく経ってからやり直してください。");
              } else {
                this.$emit("errorToast", "レビューの更新に失敗しました。しばらく経ってからやり直してください。");
              }
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      }
    },
    /** 登録・更新時、不要な依頼コンテンツ削除 */
    deleteDealContentsNotNeed() {
      switch (this.reviewData.dealType) {
        case Code:
          this.reviewData.githubUrl = null;
          this.reviewData.fileUrl = null;
          break;
        case ZipFile:
          this.reviewData.codeEditor = [] as CodeEditorSegmegment[];
          this.reviewData.githubUrl = null;
          break;
        case GithubUrl:
          this.reviewData.codeEditor = [] as CodeEditorSegmegment[];
          this.reviewData.fileUrl = null;
          break;
      }
    },
    alertSkill(message: string) {
      this.$emit("errorToast", message);
    },
    setColorClass(lang: string): string {
      return getColorClass(lang);
    },
  },
  filters: {
    remainingDays(period: string): string {
      const remain = getDaysCountToEndDate(new Date(period));
      return remain < 0 ? "期限切れ" : `残り ${remain} 日`;
    },
    formatDate(date: string, fmt: string): string {
      return moment(date).format(fmt);
    },
  },
});
